/**
 * The query keys the whole suite shares.
 *
 * Centralised because invalidation is the point: signing out has to drop the
 * session AND every account list, and revoking a device has to refresh the
 * sessions list too. A component that invents its own key string invalidates
 * nothing, and the stale data it leaves on screen is another user's device
 * list after a logout.
 */
export const sessionKeys = {
    session: ["session"],
    profile: ["account", "profile"],
    securityEvents: ["account", "security-events"],
    devices: ["account", "devices"],
    sessions: ["account", "sessions"],
    deviceApprovals: ["account", "device-approvals"],
    all: ["account"],
};
//# sourceMappingURL=keys.js.map